import moment from 'moment';

export const measurementHasEnded = function(measurementEnd) {
  return measurementEnd
    && moment(measurementEnd).utcOffset(0)
      .isBefore(moment().startOf('day'));
};

/**
 * Returns the temporal bounds for the charts as Date instances.
 *
 * Based on how many days ago should be included and if the measurement ended.
 * If the measurement ended (end date yesterday or earlier), then the bounds
 * are that of the whole measurement period unless <var>daysAgo</var> is a number;
 * if it has not ended yet, the upper bound is now.
 *
 * @param  {Object} bounds
 * Properties:
 *   {string} start    Start of measurement (UTC) in a format supported by Moment.js
 *   {string} end      End of measurement (UTC), if available, in a format supported
 *                     by Moment.js; empty string otherwise
 *   {number} daysAgo  Number of days ago that the chart should start (optional)
 * @return {Object{{Date} start, {Date} end}}  Time bounds to be used
 */
export const getRealDateBounds = function(bounds) {
  const NOW = moment();

  if (typeof bounds.daysAgo === 'number') {
    bounds.start = NOW.clone().subtract(bounds.daysAgo, 'days');
    bounds.end = NOW;
  } else {
    bounds.start = moment(bounds.start).utcOffset(0);

    if (bounds.end) {
      bounds.end = moment(bounds.end).utcOffset(0);
    }

    const MEASUREMENT_HAS_ENDED = bounds.end && bounds.end.isBefore(NOW.startOf('day'));

    if (!MEASUREMENT_HAS_ENDED) bounds.end = NOW;
  }

  delete bounds.daysAgo;

  return bounds;
};



// WEBPACK FOOTER //
// ./theme_src/js/date.js